var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 55.64 55.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-rule: evenodd;\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.15,14.23l-2.42-1.13-2.42-1.13-5.01,5.01,1.06-1.06s-.01,0-.02,0l-4.95,4.92c6.91.98,12.17,5.86,12.17,11.72,0,6.57-6.6,11.9-14.74,11.9-5.5,0-10.3-2.43-12.83-6.04-1.22-1.73-1.91-3.73-1.91-5.86s.69-4.13,1.91-5.86c.14-.2.3-.41.45-.6,6.96-8.66,24.36-14.06,12.38-26.09,2.12,9.37-10.77,14.35-16.91,21.17l-5.78-1.8-1.4,1.96-1.4,1.96,4.89,3.19c-.44.98-.78,1.99-1.01,3.04l-6.21.79v4.52l6.21.79c.23,1.05.56,2.06,1.01,3.04l-4.89,3.19,1.4,1.96,1.4,1.96,5.87-1.83c.83.81,1.76,1.55,2.75,2.22l-2.26,4.74,2.42,1.13,2.42,1.13,3.95-3.95c1.21.36,2.47.63,3.77.81l.98,5.01h5.6l.98-5.01c1.3-.18,2.56-.46,3.77-.81l3.95,3.95,2.42-1.13,2.42-1.13-2.26-4.74c1-.67,1.92-1.42,2.75-2.22l5.87,1.83,1.4-1.96,1.4-1.96-4.89-3.19c.44-.98.78-1.99,1.01-3.04l6.21-.79v-4.52l-6.21-.79c-.22-1.05-.56-2.06-1.01-3.04l4.89-3.19-1.4-1.96-1.4-1.96-5.87,1.83c-.84-.81-1.76-1.55-2.75-2.22l2.26-4.74Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -569.5,
    y1: 519.55,
    x2: -569.4,
    y2: 519.55,
    gradientTransform: "translate(-198882.01 -292102.35) rotate(-90) scale(513.01 382.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#146eb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3bb8ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69c7bf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55.64,
    height: 55.01
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.364d06154799e7104a30ae0a9526e642.svg";
export { ForwardRef as ReactComponent };